import InfoIcon from "@mui/icons-material/Info";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Flex, FlexProps } from "./Flex";

type WarningMessageProps = FlexProps & {
    warning: string | null | undefined;
    align?: "center" | "left";
};
export const WarningMessage = ({ warning, align = "center", ...props }: WarningMessageProps) => {
    if (!warning) return null;
    return (
        <WarningWrapper middle center={align === "center"} style={{ textAlign: align }} {...props}>
            <InfoIconStyled fontSize="small" />
            <Typography variant="caption">{warning}</Typography>
        </WarningWrapper>
    );
};

const WarningWrapper = styled(Flex)(({ theme }) => ({
    gap: theme.spacing(1),
    padding: theme.spacing(0.625),
    marginTop: theme.spacing(1),
}));

const InfoIconStyled = styled(InfoIcon)(({ theme }) => ({
    fill: theme.palette.warning.main,
}));
